import PdfCell from "./PdfCell";

export default class PreperationPdf {
    constructor(orders, rows, suppliers) {
        this.orders = orders;
        this.screen_rows = rows;
        this.suppliers = suppliers;
        this.startX = 5;
        this.startY = 5;
    }

    getRows() {
        return this.rows
    }

    generatePdf() {
        const selectedRows = this.getSelectedRows();
        this.rows = [
            this.getHeaderRow()
        ];
        for (const selectedRow of selectedRows) {
            const row = {};
            const { cells, height } = this.getRowCells(this.rows, selectedRow);
            row.cells = cells;
            row.height = height;
            this.rows.push(row);
        }
    }

    getHeaderRow(){
        const columnHeight = 10;
        const row = {};
        const columns = this.getColumns();
        const cells = [];
        for(const column of columns){
            const x = column.x;
            const y = this.startY;
            const width = column.width;
            const height = columnHeight;
            const text = column.text;
            const fontSize = column.fontSize;
            const border = column.border;
            const align = column.align;
            const fontType = "b";
            cells.push(new PdfCell(x, y, width, height, text, fontSize, border, align, fontType))
        }
        row.cells = cells;
        row.height = columnHeight;
        return row;
    }

    getSelectedRows() {
        const selectedRows = this.screen_rows.filter(row => {
            if (row.type != "order") {
                return false;
            }
            const order = row.object;
            const orderIndex = this.orders.indexOf(order);
            if (orderIndex == -1) {
                return false;
            }
            return true;
        })
        return selectedRows;
    }

    getRowCells(previousRows, row) {
        const columns = this.getColumns();
        let height = 0;
        const cells = [];
        for (const column of columns) {
            const cell = row.cells.find(rowCell => {
                if (rowCell.name == column.name) {
                    return true;
                }
                return false;
            });
            if (!cell) {
                continue;
            }
            const x = column.x;
            const y = this.getY(previousRows);
            const width = column.width;
            height = Math.max(height, 6); // calculate properly
            const text = cell.text;
            const fontSize = column.fontSize;
            const border = column.border;
            const align = column.align;
            cells.push(new PdfCell(x, y, width, height, text, fontSize, border, align))
        }
        return { cells, height };
    }

    getColumns() {
        let columns = [
            {
                name: "production_id",
                width: 25,
                fontSize: 8,
                border: true,
                align: null,
                text: "Užsakymas",
            },
            {
                name: "customer_name",
                width: 30,
                fontSize: 8,
                border: true,
                align: null,
                text: "Klientas",
            },
            {
                name: "manager_name",
                width: 15,
                fontSize: 8,
                border: true,
                align: null,
                text: "Vadyb",
            },
            {
                name: "product_type",
                width: 20,
                fontSize: 8,
                border: true,
                align: null,
                text: "Tipas",
            },
            {
                name: "products_area",
                width: 10,
                fontSize: 8,
                border: true,
                align: "R",
                text: "Plotas",
            },
            {
                name: "wood_type",
                width: 18,
                fontSize: 8,
                border: true,
                align: null,
                text: "Med",
            },
            {
                name: "paint_type",
                width: 10,
                fontSize: 8,
                border: true,
                align: null,
                text: "Daž",
            },
            {
                name: "element_count",
                width: 10,
                fontSize: 8,
                border: true,
                align: null,
                text: "Kabl",
            },
            {
                name: "spross_count",
                width: 10,
                fontSize: 8,
                border: true,
                align: null,
                text: "Špros",
            },
            {
                name: "other_suppliers",
                width: 10,
                fontSize: 8,
                border: true,
                align: null,
                text: "Kita"
            },
            {
                name: "predicted_date",
                width: 20,
                fontSize: 8,
                border: true,
                align: null,
                text: "Galima data",
            },
            {
                name: "due_date",
                width: 20,
                fontSize: 8,
                border: true,
                align: null,
                text: "Terminas",
            },
        ];
        this.suppliers.slice().reverse().forEach((supplier) => {
            columns.splice(9, 0, {
                name: `supplier_${supplier.id}`,
                width: 10,
                fontSize: 8,
                border: true,
                align: null,
                text: supplier.short_title,
            })
        });
        columns.forEach((column, i) => {
            column.x = this.getX(columns.slice(0, i));
        });
        return columns;
    }

    /**
     * gets column X according to previous columns widths
     * @param {Array} previousColumns
     */
    getX(previousColumns) {
        let x = this.startX; //starting from x
        previousColumns.forEach(column => {
            x += column.width;
        });
        return x;
    }

    /**
     * get row Y according to previous rows heights
     * @param {Array} previousRows 
     */
    getY(previousRows) {
        let y = this.startY; //starting from y
        previousRows.forEach(row => {
            y += row.height;
        });
        return y;
    }
}